// キャメルケースをスネークケースに変換する関数
const toSnakeCase = (str: string): string => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

// オブジェクトのキーを再帰的に変換する関数
const convertKeysToSnakeCase = (obj: object): object => {
  if (Array.isArray(obj)) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return obj.map((item) => convertKeysToSnakeCase(item));
  } if (!!obj && obj.constructor === Object) {
    return Object.keys(obj).reduce((acc, key) => {
      const snakeKey = toSnakeCase(key);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      acc[snakeKey] = convertKeysToSnakeCase(obj[key]);
      return acc;
    }, {} as object);
  }
  return obj;
};

const requestUtil = {
  convertKeysToSnakeCase,
};

export default requestUtil;
